export default "__VITE_ASSET__B54fl23___"